import { IEvent } from '../models/events-models';
import EventMapper from '../mappings/event-mapper';
import { Config } from '../models/config-viewmodel';

class EventService {
    private eventMapper = new EventMapper();

    constructor() {}

    public getSchedule = (config: Config, date: Date, HttpService: any) => {
        return this.getGrades(this.getScheduleQuery(config, date), HttpService);
    }

    private getGrades = (url: string, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.getList(url).then((result: IEvent[]) => {
                resolve(result.map((event: IEvent) => this.eventMapper.mapEvent(event)));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }

    private getScheduleQuery = (config: Config, date: Date): string => {
        return `${config.apiBasePath}/api/study/events/${config.userId}/${config.language}/${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }
}

export default new EventService();